import { nameof } from '@work4all/data/lib/helper/nameof';

import { VisitationReport } from '@work4all/models/lib/Classes/VisitationReport.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/visitationReport-table-schema.json';

const defaultSort = [
  {
    field: nameof<VisitationReport>('startTime'),
    direction: SortDirection.DESCENDING,
  },
];

export function VisitationReportsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<VisitationReport, never>({
    ...props,
    schema: schema as never,
    defaultSort,
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
